export default "__VITE_ASSET__BCQT$ORL__"